const Platforms = Object.freeze({
  YellowSchool: 'yellow-school',
  ShanghaiBloggersCLub: 'sbc',
  UkrChat: 'ukr-chat',
});

export default Platforms;
